import React, { useState, useContext, useEffect } from "react";
import { auth, db } from "../firebase";
import { getAllMentors } from "../utils";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  function signupGoogle(provider) {
    return auth.signInWithPopup(provider);
  }

  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
  }

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    return auth.signOut();
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email);
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password);
  }

  function emailVerification() {
    return currentUser.sendEmailVerification();
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);

      if (currentUser) {
        if (sessionStorage.getItem("authUser") == null) {
          const fetchUserData = async () => {
            return await db
              .collection("users")
              .doc(currentUser.uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  let data = doc.data();
                  sessionStorage.setItem("authUser", JSON.stringify(data));
                } else {
                  db.collection("mentors")
                    .doc(currentUser.uid)
                    .get()
                    .then((doc) => {
                      if (doc.exists) {
                        sessionStorage.setItem(
                          "authUser",
                          JSON.stringify(doc.data())
                        );
                      } else {
                        let isRegistered = {
                          registered: false,
                        };
                        sessionStorage.setItem(
                          "isRegistered",
                          JSON.stringify(isRegistered)
                        );
                      }
                    });
                }
              });
          };
          fetchUserData();
        }

        if (sessionStorage.getItem("mentorData") == null) {
          getAllMentors().then((data) => {
            sessionStorage.setItem("mentorData", JSON.stringify(data));
          });
        }
      }
    });

    return unsubscribe;
  }, [currentUser]);

  const value = {
    currentUser,
    signup,
    signupGoogle,
    login,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
    emailVerification,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
